"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (props) {
    var classes = [];
    var newProps = __assign({}, props);
    var styleOptions = props.styleOptions;
    if (!styleOptions) {
        // No style utilities provided
        return [[], props];
    }
    var styleUtilityProps = Object.entries(styleOptions);
    styleUtilityProps.forEach(function (_a) {
        var propName = _a[0], propValue = _a[1];
        if (!propValue) {
            return;
        }
        switch (propName) {
            case "flex": // Fall through
            case "position":
                // Special case for these props since they hold more complex types
                Object.entries(propValue).forEach(function (_a) {
                    var _key = _a[0], value = _a[1];
                    return classes.push(value);
                });
                break;
            default:
                // For utilities such as Padding, it is possible to supply
                // an array of enum values.
                // If the value is an array of values, spread it out.
                if (Array.isArray(propValue)) {
                    classes.push.apply(classes, propValue);
                }
                else if (typeof propValue === "string") {
                    classes.push(propValue);
                }
                else {
                    console.error("Received a Utility prop value that was not an array, string, or special case that we handle. Check your prop types for " +
                        propName);
                }
        }
    });
    // After all of the props have been processed,
    delete newProps.styleOptions;
    return [classes, newProps];
});
//# sourceMappingURL=distillUtilityClasses.js.map